module.exports = __webpack_public_path__ + "img/icon-left.3f188eca.svg";